import { memo, useMemo, useEffect } from 'react';
import { RegistrationFormProps } from './RegistrationForm.types';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  fetchRegistrationOffers,
  selectRegistrationOffersDataState,
} from '../../state';
import { Box } from '@betty/moonlight';
import RegistrationStep from '../RegistrationStep/RegistrationStep';
import RegistrationProgressHeader from '../RegistrationProgressHeader/RegistrationProgressHeader';
import RegistrationNavigationHeader from '../RegistrationProgressHeader/RegistrationNavigationHeader/RegistrationNavigationHeader';
import { useTranslation } from '@betty/i18n';

function RegistrationForm({
  config,
  activeStepId,
  onStepSubmit,
  submitDataState,
}: RegistrationFormProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation('registration');
  const registrationOffersDataState = useSelector(
    selectRegistrationOffersDataState,
  );

  const stepIndex = useMemo(
    () => config.steps.findIndex((step) => step.id === activeStepId) || 0,
    [config.steps, activeStepId],
  );
  const step = config.steps[stepIndex];

  useEffect(() => {
    if (registrationOffersDataState === 'idle') {
      dispatch(fetchRegistrationOffers());
    }
  }, [registrationOffersDataState, dispatch]);

  return (
    <Box flex={1}>
      <RegistrationNavigationHeader
        options={{ title: t('createBettyAccount') }}
      />
      {step?.disableHeader ? null : <RegistrationProgressHeader />}
      <Box flex={1}>
        <RegistrationStep
          key={step.id}
          step={step}
          onSubmit={onStepSubmit}
          submitDataState={submitDataState}
        />
      </Box>
    </Box>
  );
}

export default memo(RegistrationForm);
